export default __webpack_public_path__ + "static/media/iconClose.bf9ebaf9.svg";